export const formatPath = (name: string): string => {
  try {
    // Only decode if the string appears to be URI encoded
    const decodedName = /%[0-9a-f]{2}/i.test(name) ?
      decodeURIComponent(name) :
      name;

    return decodedName
      .replace(/_/g, "-")
      .replace(/&/g, "and")
      .replace(/,/g, "")
      .replace(/\./g, "")
      .replace(/'/g, "")
      .replace(/%/g, "percent") // Add handling for % character
      .replace(/\s+/g, "-")
      .replace(/-+/g, "-")
      .toLowerCase();
  } catch (error) {
    console.error(`Error formatting path for: ${name}`, error);
    return name.toLowerCase(); // Fallback to just lowercase original name
  }
};

export const formatCurrencyCompact = (value: number) => {
  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
    notation: 'compact',
  });
  return formatter.format(value);
};